import { Button } from '../../components/Buttons'
import Cards from '../../components/Cards'
import InputField from '../../components/InputField'
import { useForm, Controller } from 'react-hook-form'
import { validationConstants } from '../../constants/validations'
import FileInput from '../../components/FileInput'
import { Input, Select } from 'antd'
import { useGetGeneralSettingsQuery, useSubmitSupportFormMutation } from '../../services/settingsSlice'
import Loading from '../../components/Loading'
import { useEffect, useState } from 'react'
import { HomeIcon, Telegram } from '../../components/Icons/iconImages'
import { toast } from '../../components/Toast/toast'
import { useNavigate } from 'react-router-dom'
import Checkbox from '../../components/Checkbox'
import Icons from '../../components/Icons'
const { TextArea } = Input;

function ReportIssue() {

  const [submitSupportForm, { isLoading: isUpdateLoading, isSuccess: updateSuccess, isError: updateError, error: updateErrorData }] = useSubmitSupportFormMutation();
  const { data: getUserData } = useGetGeneralSettingsQuery('');
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);

  const issueTypes = [
    { value: 'Facing a response error on my queries', label: 'Facing a response error on my queries' },
    { value: 'Integration related issues', label: 'Integration related issues' },
    { value: 'Dashboard and widget issues', label: 'Dashboard and widget issues' },
    { value: 'Payment related issues', label: 'Payment related issues' },
    { value: 'Refunds and cancellations', label: 'Refunds and cancellations' },
    { value: 'Report a bug', label: 'Report a bug' },
  ];

  const defaultValues = {
    issueType: "",
    screenshot: "",
    description: "",
    email: "",
    agreeToPrivacy: false,
  };

  const {
    getValues,
    setValue,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    reset
  } = useForm({
    defaultValues,
  });

  useEffect(() => {
    if (getUserData?.settings) {
      setValue('email', getUserData?.settings?.email || '');
    }
  }, [getUserData, setValue])

  const handleSave = (data: any) => {
    const payload = {
      "issue_type": data.issueType,
      "screenshot": data.screenshot || "",
      "additional_details": data.description || "",
      "email": data.email,
      "agree_to_terms": data.agreeToPrivacy
    }
    submitSupportForm(payload);
  }
  console.log("errors", errors);

  useEffect(() => {
    if (updateSuccess) {
      toast.success('Your issue has been submitted successfully');
      setShowSuccess(true);
      reset();
    }
    if (updateError) {
      console.log("error", updateErrorData);
      const errorMessage = updateErrorData && 'data' in updateErrorData ?
        (updateErrorData as any)?.data?.message || 'Failed to submit issue' :
        'Failed to submit issue';
      toast.error(errorMessage);
    }
  }, [updateSuccess, updateError, updateErrorData, reset]);

  if (isUpdateLoading) {
    return <Loading />;
  }

  return (

    <div className='mt-4 container mx-auto px-4 md:px-8 lg:px-24'>
      <nav aria-label="Breadcrumb" className='breadcrumbs hidden md:block'>
        <ol>
          <li key={'settings-icons'}>
            <div className="flex items-center">
              <p className="inline-flex items-center gap-1 text-md font-medium text-gray-700">
                <HomeIcon className={"h-[1.25rem] w-[1.25rem] text-text-600"} />
                <Icons icon="heroicons-outline:chevron-right" alt="settings-icon" className={"h-4 w-4 text-text-300"} />
              </p>
            </div>
          </li>
          <li key={'settings-label'}>
            <div className="flex items-center">
              <p className="inline-flex items-center gap-1 text-md font-medium text-gray-700 ">
                Support
                <Icons icon="heroicons-outline:chevron-right" alt="settings-icon" className={"h-4 w-4 text-text-300"} />
              </p>
            </div>
          </li>
          <li key={'settings-label'}>
            <div className="flex items-center">
              <p className="inline-flex items-center gap-1 text-md font-semibold text-[#609F81] ">
                Report an Issue
              </p>
            </div>
          </li>

        </ol>
      </nav>


      <Cards variant="secondary" classname="p-4 md:p-6" childClassName="flex-col" title="" bottomButton={undefined}>
        {!showSuccess ? (
          <>
            <div className="flex w-full justify-between items-start border-b border-solid border-gray-300 pb-4">
              <div>
                <h4 className="text-[#181D27] font-semibold text-base md:text-lg">Get In Touch</h4>
                <h5 className="font-normal text-[#535862] text-xs md:text-sm">Please share the details of your issue and we'll get back to you as soon as possible.</h5>
              </div>
            </div>

            <form onSubmit={handleSubmit(handleSave)} className="mt-6 md:mt-12 pt-3 w-full md:w-[75%] lg:w-[60%] xl:w-[50%] mx-auto">

              {/* Issue Type Selection */}
              <div className="mb-4">
                <p className="text-sm text-[#414651] font-medium mb-2">
                  Select Issue <span className="text-red-500">*</span>
                </p>
                <Controller
                  control={control}
                  name="issueType"
                  rules={{
                    required: { value: true, message: "Please select an issue type" },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Select
                        {...field}
                        className="w-full"
                        size="large"
                        options={issueTypes}
                        placeholder="Select issue type"
                        onChange={(value) => field.onChange(value)}
                        status={error ? "error" : ""}
                      />
                      {error && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
                    </>
                  )}
                />
              </div>

              {/* Screenshot Upload */}
              <div className="mb-4">
                <p className="text-sm text-[#414651] font-medium mb-2">
                  Upload Screenshot
                </p>
                <FileInput
                  control={control}
                  name="screenshot"
                  rules={{
                    required: false,
                    allowedFileTypes: ["SVG", "PNG", "JPG", "GIF", "JPEG"],
                    maxDimensions: { width: 4000, height: 4000 },
                    maxFileSize: 5 * 1024 * 1024, // 5MB
                  }}
                />

              </div>

              {/* Additional Details - OPTIONAL */}
              <div className="mb-4">
                <Controller
                  name="description"
                  control={control}
                  rules={{
                    required: false,
                    maxLength: {
                      value: 1000,
                      message: "Description must not exceed 1000 characters"
                    }
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <label htmlFor="description" className="text-sm font-medium text-[#414651] mb-2 block">
                        Additional details
                      </label>
                      <TextArea
                        {...field}
                        id="description"
                        rows={6}
                        placeholder="Please describe your issue in detail..."
                        className="rounded-2xl"
                        status={error ? "error" : ""}
                        showCount
                        maxLength={1000}
                      />
                      {error && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
                      <p className="text-[#535862] font-normal text-xs mt-2">
                        Please describe your issue in detail. The more info you share, the faster we can help.
                      </p>
                    </>
                  )}
                />
              </div>

              {/* Email Address - MANDATORY */}
              <div className="mb-4">
                <InputField
                  control={control}
                  label="Email"
                  placeholder="your.email@example.com"
                  type="email"
                  name="email"
                  rules={{
                    required: "Email is required",
                    ...validationConstants.email,
                  }}
                  error={errors.email}
                />
              </div>

              {/* Privacy Policy Checkbox - MANDATORY */}
              <div className="mb-6">
                <Controller
                  name="agreeToPrivacy"
                  control={control}
                  rules={{
                    required: "You must agree to the privacy policy to continue",
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <div className="">
                        <input
                          type="checkbox"
                          id="agreeToPrivacy"
                          checked={field.value}
                          onChange={(e) => field.onChange(e.target.checked)}
                          className="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-primary-600 focus:ring-primary-500 cursor-pointer"
                        />
                        <label htmlFor="agreeToPrivacy" className="ml-2 text-sm text-[#414651] cursor-pointer">
                          You agree to our{' '}
                          <a
                            href="https://oogw.ai/privacy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary-600 hover:text-primary-700 underline"
                            onClick={(e) => e.stopPropagation()}
                          >
                            Privacy Policy
                          </a>
                          <span className="text-red-500 ml-1">*</span>
                        </label>
                      </div>
                      {error && <p className="text-red-500 text-xs mt-1.5 ml-6">{error.message}</p>}
                    </>
                  )}
                />
              </div>

              <Button
                type="primary"
                htmlType="submit"
                loading={isUpdateLoading}
                className="mt-4 w-full"
                disabled={isUpdateLoading}
              >
               Send Request
              </Button>
            </form>
          </>
        ) : (
          <div className="px-4 md:px-0">

            <div className="flex w-full justify-between items-start border-b border-solid border-gray-300 pb-4">
              <div>
                <h4 className="text-[#181D27] font-semibold text-base md:text-lg">Get In Touch</h4>
                <h5 className="font-normal text-[#535862] text-xs md:text-sm">Please share the details of your issue and we'll get back to you as soon as possible.</h5>
              </div>
            </div>

            <div className='w-full md:w-[75%] lg:w-[60%] xl:w-[50%] mx-auto py-6 md:py-8'>
              <div className='flex items-center gap-2 md:gap-3 mb-4'>
                <Telegram className="w-8 h-8 md:w-10 md:h-10 flex-shrink-0" />
                <h3 className="text-lg md:text-xl lg:text-2xl font-medium text-[#4C8067]">Issue Submitted Successfully!</h3>
              </div>

              <p className="text-sm md:text-base text-[#414651] mb-6 md:mb-8">
                We've got your request! Our team usually responds within 1 working hour (or the next working day if you've reached us after hours).
              </p>
              <div className="w-full">
                <Button
                  type="primary"
                  onClick={() => setShowSuccess(false)}
                  className="w-full"
                >
                  Submit Another Issue
                </Button>
              </div>
            </div>

          </div>
        )}
      </Cards>
    </div>

  )
}

export default ReportIssue